import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Banner from './components/Banner';
import { BannerExtension, SkipNav } from '@ver-uds/uswds-react';
import { AuthServiceProvider, AuthStateProvider, VisAuthService } from '@vis-auth/react';
import SessionTimeout from './components/session-timeout.component';
import HeaderLinks from './components/header-links.component';
import { I18nextProvider } from 'react-i18next';
import i18n from './localization/i18n';

export default function Root({ authService, routeConfig }: { authService?: VisAuthService; routeConfig: any }) {
  return (
    <>
      <SkipNav.Anchor />
      <I18nextProvider i18n={i18n}>
        <Banner extensionType={BannerExtension.GOV} />
        <BrowserRouter>
          <AuthServiceProvider value={authService}>
            <AuthStateProvider>
              <SessionTimeout />
              <HeaderLinks routeConfig={routeConfig} />
            </AuthStateProvider>
          </AuthServiceProvider>
        </BrowserRouter>
      </I18nextProvider>
    </>
  );
}
